<template>
  <el-skeleton class="sk" animated>
    <template #template>
      <el-skeleton-item variant="image" class="sk__image" />
      <el-skeleton-item variant="p" class="sk__name" />
    </template>
  </el-skeleton>
</template>

<script setup>

</script>

<style lang="scss" scoped>
.sk {
  background-color: rgba(#898989, 0.1);
  width: 362px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  border-radius: 30px;
  padding: 25px;

  &__image {
    width: 100%;
    height: 360px;
    border-radius: 10px;
  }

  &__name {
    width: 80%;
  }
}

@media (max-width: 1300px) {
  .sk {
    width: 300px;
  }
}
</style>